<template>
	<div class="paramselect">
		<h6>{{title}}</h6>
		<ul :class="'list-group radio ' + name">
			<li class="list-group-item" v-for="(i,index) in options" :key="index">
			<label>
				<input type="radio" :id="name + '_' + (i[valuecol2]).replace(' ', '_')" :name="name" :value="i[valuecol2]" :checked="value ? index === 0 : value == i.value" @change="updateValue"/>
				<span>{{i[namecol2]}}</span>
			</label>
			</li>
		</ul>
	</div>
</template>

<script>

export default{
	props:["name", "title", "options", "value", "namecol", "valuecol"],
	components:
	{
	},
	computed:
	{
		namecol2() {
			return this.namecol ? this.namecol : 'name'
		},
		valuecol2() {
			return this.valuecol ? this.valuecol : 'value'
		},
	},
	mounted()
	{
		document.querySelector('.paramselect input[id=' + this.name + "_" + this.value.replace(' ', '_') + ']').checked = true
	},
	methods:
	{
		updateValue() {
			var selected = document.querySelector('.paramselect input[name=' + this.name + ']:checked').value
			this.$emit('input', selected)
		}
	}
}

</script>
<style>

.paramselect .list-group {
    flex-wrap: wrap;
    flex-direction: row;
    padding: 0px;
    margin: 0px;
    border: none;
    background: none;
}

.paramselect .list-group .list-group-item {
	position: relative;
    display: block;
	padding: 0px;
	margin: 0px;
	border: none;
	background: none;
}

.paramselect .radio label input {
	position: absolute;
	z-index: -1;
	top: -2000px;
}

.paramselect .radio label span {
	text-align: center;
	font-size: 12px;
	padding: 5px 5px;
	display: block;
	color: #666;
	font-weight: normal;
	cursor: pointer;
}

.paramselect .radio input:checked + span {
    background-color: #ddd;
    color: #333;
    font-weight: bold;
}

</style>
